/**
 * @desc 样品确认-修改并提交工作流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductConfirmResponseDto>;
export function request(
  body: defs.basics.ProductConfirmRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/updateAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
